const initialState = {
    changePasswordModal: false,
    addRealtorModal: false,
    viewBuyerDetails: false,
    addOrganisationModal: false,
};

const modalHandler = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_PASSWORD': return {
            ...state,
            changePasswordModal: action.payload
        }
        case 'ADD_REALTOR': return {
            ...state,
            addRealtorModal: action.payload,
            editRealtorData: action.data,
            refreshList: action.isUpdated
        }
        case 'VIEW_BUYER_DETAILS': return {
            ...state,
            viewBuyerDetails: action.payload,
            buyerId: action.buyerId,
            showReview: action.showReview,
            address: action.address
        }
        case 'ADD_ORGANISATION': return {
            ...state,
            addOrganisationModal: action.payload,
            editOrganisationData: action.data,
            refreshList: action.refreshList
        }
        default:
            return state
    }
}

export default modalHandler;
